import React, { useState } from "react";
import "./Accordion.css";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ title, children }) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className="accordion">
      <button
        className="accordion-toggle"
        onClick={() => setOpen(!open)}
        type="button"
      >
        {open ? "▾" : "▸"} {title}
      </button>
      {open && <div className="accordion-content">{children}</div>}
    </div>
  );
};

export default Accordion;
